import React, { Component } from 'react';
import { connect } from 'react-redux';

import { badgeConfig } from './../../conf/config';

import firebaseApp from './../../utils/firebase/firebase';

import * as pointsActions from './pointsActions';

import Modal from './../UI/Modal/Modal';

export class Points extends Component {

    calculPointsFromHistory = () => {
        
        firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }/history`)
            .once('value')
            .then( (snapshot) => {
                const history = {};
                snapshot.forEach((historyLine) => {
                    const { action, points } = historyLine.val();
                    const { entityId } = historyLine.val().entity;

                    if(!history.hasOwnProperty(action + entityId) && points !== 0)
                    {
                        history[action + entityId] = {points, addToTotal: true};
                        if(action === 'order')
                        {
                            history[action + entityId] = {points: points * -1, addToTotal: false};
                        }
                        if(action === 'refund')
                        {
                            history[action + entityId].addToTotal= false;
                        }
                        
                    }

                });

                const historyPoints = Object.values(history);
                let totalPoints = 0;
                let currentPoints = 0;
                historyPoints.forEach((historyEntry) => {
                    totalPoints += historyEntry.addToTotal?historyEntry.points:0;
                    currentPoints += historyEntry.points;
                });

                pointsActions.updateFirebasePoints(currentPoints, totalPoints);

            })
            .catch((err) => {
                console.error(err);
            });
    }

    componentDidMount(){

        const { dispatch } = this.props;

        firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }/points`)
            .on('value', (snapshot) => {
                if( snapshot.val() ) {
                    const { currentPoints, totalPoints } = snapshot.val();
                    dispatch( pointsActions.processUpdatedPoints(currentPoints, totalPoints) );
                }
                else dispatch( pointsActions.processUpdatedPoints(0, 0) );               
            });

        this.calculPointsFromHistory();

        this.interval = setInterval(this.calculPointsFromHistory, 86400000);
    }

    closeModalHandler = () => {
        const { badgeToAttribute, dispatch } = this.props;
        dispatch(pointsActions.updateBadgeToAttribute(badgeToAttribute));
    }
    
    render(){
        const { badgeToAttribute } = this.props;
        let modal = null;
        let modalClass = 'modal-badge-earned';
        if (badgeToAttribute.includes(true)){

            if(badgeConfig[badgeToAttribute.indexOf(true)].name.length > 15)
            {
                modalClass += ' long';
            }

            modal = (
                <div className="badge-earned">
                    <div className="modal-container">
                        <div className="close-button" onClick={this.closeModalHandler}></div>
                        <div className="content">
                            <img src={badgeConfig[badgeToAttribute.indexOf(true)].imgHover} alt={`${badgeConfig[badgeToAttribute.indexOf(true)].name}`}/>
                        </div>
                        <div className="congratulation">Bravo!</div>
                        <div className="text">Tu as débloqué le badge {badgeConfig[badgeToAttribute.indexOf(true)].name}</div>
                        <div className="footer">En gagnant {badgeConfig[badgeToAttribute.indexOf(true)].pointsRequired} points</div>
                    </div>
                </div>
            );
        }

        return (
                <Modal show={badgeToAttribute.includes(true)} modalClosed={this.closeModalHandler} class={modalClass}>
                    {modal}
                </Modal>
        );
        
    }
}

const mapStateToProps = state => {
    return {
        badgeToAttribute: state.points.badgeToAttribute
    }
};

  
export default connect( mapStateToProps )(Points);



// WEBPACK FOOTER //
// ./src/components/Points/Points.js